<div class="corporates-admin-table">
  <div class="table-actions">
    <div></div>
    <div class="actions-right">
      <button mat-flat-button color="primary" (click)="startAdd()"><mat-icon>add</mat-icon>&nbsp;Añadir
    corporativo</button>
  </div>
</div>

@if (showForm) {
  <div class="add-form">
    <h3>Añadir corporativo</h3>
    <form [formGroup]="corporateForm" (ngSubmit)="save()" class="corporate-form">
      <div class="form-row">
        <mat-form-field class="full" appearance="outline">
          <mat-label>Nombre del corporativo</mat-label>
          <input matInput formControlName="name_corporate" placeholder="Nombre del corporativo" />
          @if (corporateForm.get('name_corporate')?.hasError('required')) {
            <mat-error>Campo requerido</mat-error>
          }
          @if (corporateForm.get('name_corporate')?.hasError('maxlength')) {
            <mat-error>Máximo 100 caracteres</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field class="full" appearance="outline">
          <mat-label>Nombre del usuario</mat-label>
          <input matInput formControlName="name_user" placeholder="Nombre del usuario" />
          @if (corporateForm.get('name_user')?.hasError('required')) {
            <mat-error>Campo requerido</mat-error>
          }
          @if (corporateForm.get('name_user')?.hasError('maxlength')) {
            <mat-error>Máximo 50 caracteres</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field class="full" appearance="outline">
          <mat-label>Apellido del usuario</mat-label>
          <input matInput formControlName="last_name_user" placeholder="Apellido del usuario" />
          @if (corporateForm.get('last_name_user')?.hasError('required')) {
            <mat-error>Campo requerido</mat-error>
          }
          @if (corporateForm.get('last_name_user')?.hasError('maxlength')) {
            <mat-error>Máximo 50 caracteres</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field class="full" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="Email" />
          @if (corporateForm.get('email')?.hasError('required')) {
            <mat-error>Campo requerido</mat-error>
          }
          @if (corporateForm.get('email')?.hasError('email')) {
            <mat-error>Email inválido</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-flat-button color="primary" type="submit"
        [disabled]="corporateForm.invalid">Guardar</button>
        <button mat-button type="button" (click)="cancel()">Cancelar</button>
      </div>
    </form>
  </div>
}


<div class="table-wrapper">
  @if (dataCorporate && dataCorporate.length) {
    <table class="admin-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <!-- <th>Usuarios</th> -->
        </tr>
      </thead>
      <tbody>
        @for (c of dataCorporate; track trackById(i, c); let i = $index) {
          <tr>
            <td class="id-cell">
              <div class="id-text">{{ c.id }}</div>
            </td>
            <td>{{ c.name }}</td>
            <!-- <td class="row-actions">
            <button class="btn small" (click)="getUseersCorporates(c, i)">Usuarios</button>
          </td> -->
        </tr>
      }
    </tbody>
  </table>
} @else {
  <div class="empty">No hay corporativos para mostrar.</div>
}
</div>